export const DEFAULT_PAYOUT_CARDS_FORM = Object.freeze({
  amount: "0",
  card_number: undefined,
  symbol: undefined,
})

export const DEFAULT_MANUAL_CARDS_PAYOUTS_FORM = {
  payouts: [{ ...DEFAULT_PAYOUT_CARDS_FORM }],
}
